import type { OptionI18nInput, SubOptionItemInput } from "@/lib/gql/__generated__/graphql";

import type { ProductOptionI18nFormModel } from "../../../type";

type Props = {
	viewModel: ProductOptionI18nFormModel["ViewModel"];
};

export const viewModelToOptionInputConverter = ({ viewModel }: Props): OptionI18nInput => {
	const input: OptionI18nInput = {
		hotelID: viewModel.hotelID,
		optionID: viewModel.optionID,
		lang: viewModel.lang,

		name: viewModel.name.value,

		description: viewModel.description.value,

		subOptions: viewModel.subOptions?.value?.map((item) => {
			return {
				endAt: item.endAt?.value,
				isNextMorning: item.isNextMorning?.value,
				isShowTimeSchedule: item.isShowTimeSchedule?.value,
				maxDailyStockNum: item.maxDailyStockNum.value,
				memo: item.memo?.value,
				name: item.name.value,
				price: {
					amount: item.price.amount.value,
					currencyType: item.price.currencyType.value,
				},
				startAt: item.startAt?.value,
				subOptionID: item.subOptionID?.value,
			} satisfies SubOptionItemInput;
		}),
	} satisfies OptionI18nInput;

	return input;
};
